import QuestIntensityIcon from "@/assets/image/icons/filter/icon-filter_intensity.svg?inline";
import QuestDurationIcon from "@/assets/image/icons/filter/icon-filter_timeframe.svg?inline";
import QuestLocationIcon from "@/assets/image/icons/filter/icon-filter_location.svg?inline";
import QuestPartOfDayIcon from "@/assets/image/icons/filter/icon-filter_day.svg?inline";
import QuestThemeIcon from "@/assets/image/icons/filter/icon-filter_theme.svg?inline";
import QuestMaterialIcon from "@/assets/image/icons/filter/icon-filter_material.svg?inline";
import QuestSubjectIcon from "@/assets/image/icons/filter/icon-filter_subject.svg?inline";

export default {
    components: {
        QuestIntensityIcon,
        QuestDurationIcon,
        QuestLocationIcon,
        QuestPartOfDayIcon,
        QuestThemeIcon,
        QuestMaterialIcon,
        QuestSubjectIcon
    }
}